/** Presentation-only date/time formatting shared across history views. */

/** e.g. "2026年8月15日 15:04". */
export const formatDateTime = (isoString: string): string =>
  new Date(isoString).toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

/** Whole minutes between two ISO timestamps, e.g. "12分". */
export const formatDurationMinutes = (startIso: string, endIso: string): string => {
  const minutes = Math.round((new Date(endIso).getTime() - new Date(startIso).getTime()) / 60000);
  return `${minutes}分`;
};
